import {BaseDtoModel} from '../../Services/Models/base-model.service';
import {endOfWeek, format, startOfWeek, sub} from 'date-fns';
import {es} from 'date-fns/locale';

export class DeliveryNotesReviewFilters extends BaseDtoModel {
  store_id!: number;
  supplier_id!: number;
  state_id!: number;
  date_from!: string;
  date_to!: string;
  with_pending_image_review!: 0 | 1;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      store_id: 0,
      supplier_id: 0,
      state_id: 0,
      date_from: format(startOfWeek(new Date(), {locale: es}), 'yyyy-MM-dd'),
      date_to: format(endOfWeek(new Date(), {locale: es}), 'yyyy-MM-dd'),
      with_pending_image_review: 0,
    });
  }

  /**
   * Crear filtros para la revisión de albaranes con un rango de 4 años
   *
   */
  static forReview(storeId: number): DeliveryNotesReviewFilters {
    const filters = new DeliveryNotesReviewFilters();
    filters.store_id = storeId;
    filters.date_from = format(sub(new Date(), {years: 4}), 'yyyy-MM-dd');
    filters.date_to = format(new Date(), 'yyyy-MM-dd');
    filters.with_pending_image_review = 1;

    return filters;
  }

}
